<template lang="pug">
    PaginatedItemsWrapper(
        scope="ex"
        type="shop_stocks"
        :items-paginated="itemsPaginated"
        routerPath="stock-form"
        :loading="loading"
        :show-add-button="checkRestrictions('ex:shop:stocks', 'create')"
        v-on:updateLoading="updateLoading"
        v-on:fetchItems="fetchItemsMethod"
        v-on:defineActiveColumns="defineActiveColumns"
        v-on:defineFilterVisibility="defineFilterVisibility"
        v-on:defineItemsPerPage="defineItemsPerPage"
        v-on:defineCurrentPage="defineCurrentPage"
        v-on:defineFilterValue="defineFilterValue"
        v-on:defineSort="defineSort"
    )
</template>

<script>
import { checkRestrictions } from '@/helpers'
import { useSetupStore, useShopStockStore } from '@/stores'

import PaginatedItemsWrapper from '@/components/PaginatedItemsWrapper';

export default {
    name: 'StocksPaginated',
    components: {
        PaginatedItemsWrapper
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms;
        },
        stockStore() {
            return useShopStockStore();
        },
        itemsPaginated() {
            return this.stockStore.itemsPaginated;
        },
        loading() {
            return this.stockStore.loading;
        },
    },
    methods: {
        fetchItemsMethod() {
            this.stockStore.fetchPaginatedItems(this.activeCms.shop.id)
                .then(() => this.stockStore.updateLoading(false))
                .catch(err => { console.log(err) });
        },
        updateLoading(value) {
            this.stockStore.updateLoading(value);
        },
        defineActiveColumns(columns) {
            this.stockStore.defineActiveColumns(columns);
        },
        defineFilterVisibility(value) {
            this.stockStore.defineFilterVisibility(value);
        },
        defineItemsPerPage(perPage) {
            this.stockStore.defineItemsPerPage(perPage);
        },
        defineCurrentPage(page) {
            this.stockStore.defineCurrentPage(page);
        },
        defineFilterValue(payload) {
            this.stockStore.defineFilterValue(payload);
        },
        defineSort(payload) {
            this.stockStore.defineSorting(payload);
        },
        checkRestrictions,
    }
};
</script>